module.exports = __webpack_public_path__ + "img/header-curso-info.5b8c1ec0.jpg";